import React from "react";
import { Box } from "@mui/material";
import { commonPageMakeStyles } from "../styles/commonPageStyles";
function BackgroundSecond(props) {
  const commonPageCss = commonPageMakeStyles();

  return (
    <Box className={`${commonPageCss.BgSecondcontainer} Survey_custom_class`}>
      <Box className={commonPageCss.BgSecondinnerContainer}>{props.children}</Box>
    </Box>
  );
}

export default BackgroundSecond;
